import { tourElementsIds, tourElementsIdsType } from "./tourElementsIds";
import { TourKey } from "./tourKeys";

export const TOUR_CONFIG: Record<
  TourKey,
  Array<{
    element: tourElementsIdsType;
    title: string;
    subtitle: string;
    behavior: "next" | "previous_next" | "previous_ok" | "ok";
  }>
> = {
  dashboard: [
    {
      element: tourElementsIds.dashboardTour1,
      title: "Business Overview",
      subtitle:
        "Track quotes, invoices, revenue, and outstanding payments at a glance.",
      behavior: "next",
    },
    {
      element: tourElementsIds.dashboardTour2,
      title: "Quick Actions",
      subtitle:
        "Create quotes, invoices, or clients instantly, everything starts here.",
      behavior: "previous_next",
    },
    {
      element: tourElementsIds.dashboardTour3,
      title: "Navigation",
      subtitle: "Use this menu to move between different sections of the app.",
      behavior: "previous_ok",
    },
  ],

  quote: [
    {
      element: tourElementsIds.quoteTour1,
      title: "Quotes",
      subtitle:
        "View and manage all your quotes here. Create new quotes, track status, and follow up.",
      behavior: "next",
    },
    {
      element: tourElementsIds.quoteTour2,
      title: "Quote Setup",
      subtitle:
        "Choose how you want to begin - start fresh or save time using templates.",
      behavior: "previous_ok",
    },
  ],

  quoteSummary: [
    {
      element: tourElementsIds.summaryItemSectionTour,
      title: "Basic Details",
      subtitle:
        "Add essential information like quote title, client, dates, and job description before moving to pricing.",
      behavior: "next",
    },
    {
      element: tourElementsIds.quoteLivePreviewTour,
      title: "Live Preview",
      subtitle:
        "Preview your quote in real time, browse templates, and download or share it instantly.",
      behavior: "previous_ok",
    },
  ],

  quoteItems: [
    {
      element: tourElementsIds.summaryItemSectionTour,
      title: "Add Items",
      subtitle:
        "Browse items, set quantities, and instantly see bill summary with margins.",
      behavior: "ok",
    },
  ],

  quoteSections: [
    {
      element: tourElementsIds.summaryItemSectionTour,
      title: "Sections",
      subtitle: "Organise your quote into clear sections to look professional.",
      behavior: "ok",
    },
  ],

  quoteDetails: [
    {
      element: tourElementsIds.quoteDetailsTour,
      title: "Woohoo!",
      subtitle:
        "Your quote is successfully created. Manage, download, or share it.",
      behavior: "ok",
    },
  ],

  presetQuote: [
    {
      element: tourElementsIds.presetQuoteTour1,
      title: "Preset Quotes",
      subtitle:
        "View and manage your quote templates. Use them while creating quotes to save time.",
      behavior: "ok",
    },
  ],

  invoice: [
    {
      element: tourElementsIds.invoiceTour,
      title: "Invoices",
      subtitle:
        "View and manage invoices, create multiple invoices from a single quote.",
      behavior: "ok",
    },
  ],

  invoiceSummary: [
    {
      element: tourElementsIds.invoiceItemSummaryTour,
      title: "Basic Details",
      subtitle:
        "Select quote, dates, and description before moving to pricing.",
      behavior: "next",
    },
    {
      element: tourElementsIds.invoiceLivePreviewTour,
      title: "Live Preview",
      subtitle:
        "Preview your quote in real time, browse templates, and download or share it instantly.",
      behavior: "previous_ok",
    },
  ],

  invoiceItems: [
    {
      element: tourElementsIds.invoiceItemSummaryTour,
      title: "Add Items",
      subtitle:
        "Browse items by category and subcategory, set quantities, and instantly see your bill summary with margins.",
      behavior: "ok",
    },
  ],

  settings: [
    {
      element: tourElementsIds.settingsTour1,
      title: "Settings",
      subtitle:
        "Manage your profile, billing, team, items, sections, payments, and notification preferences.",
      behavior: "ok",
    },
  ],
};
